import { useQuery } from "@tanstack/react-query";

import useIntegrations from "@app/analytics/hooks/integrations/useIntegrations";
import type { TeamsConversation } from "@app/analytics/types/teamsTypes";
import type { ResponseError } from "@app/common/api";
import apiClient from "@app/common/api/apiClient";
import useAuth from "@app/common/auth/useAuth";
import { hasRetryableStatus } from "@app/common/utils";

const EMPTY_CONVERSATIONS: TeamsConversation[] = [];

const useTeamsConversations = (opts?: { enabled: boolean }) => {
  const { user } = useAuth();
  const { getIntegration } = useIntegrations();

  const teamsIntegration = getIntegration({
    providerId: "microsoft_graph_teams_push",
  });

  const conversationsQuery = useQuery({
    queryKey: [user?.id, "teams", "conversations"],
    queryFn: apiClient.integrations.teams.listConversations,
    enabled: (opts?.enabled ?? true) && teamsIntegration?.isConnected,
    retry: (failureCount, error: ResponseError) =>
      failureCount < 3 && hasRetryableStatus(error),
  });

  return {
    isLoading: conversationsQuery.isLoading,
    isError: conversationsQuery.isError,
    conversations: conversationsQuery.data ?? EMPTY_CONVERSATIONS,
  };
};

export default useTeamsConversations;
